import React from 'react';
import { COMPONENT_IDS } from '~src/constants';

export type Props = {
  children: React.ReactNode;
  componentId?: COMPONENT_IDS;
};

export const ComponentIdContext = React.createContext<COMPONENT_IDS[]>([]);

export function getComponentIds() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return React.useContext(ComponentIdContext) || [];
}

export const ComponentIdContextProvider = (props: Props) => {
  if (!props.componentId) {
    return <>{props.children}</>;
  }

  const componentIds = getComponentIds();
  const value = [...componentIds, props.componentId];

  return (
    <ComponentIdContext.Provider value={value}>
      {props.children}
    </ComponentIdContext.Provider>
  );
};
